import _keys from 'lodash/keys';
import _pickBy from 'lodash/pickBy';
import _pick from 'lodash/pick';
import _without from 'lodash/without';
import _mapValues from 'lodash/mapValues';
import _union from 'lodash/union';
import {
  REQUEST_DIARY_DATA,
  RECEIVE_DIARY_DATA,
  FILTER_DIARY_DATA,
  SELECT_DIARY,
  SELECT_ALL_DIARIES,
  DESELECT_ALL_DIARIES,
} from './actions';

const initialState = {
  pending: false,
  chunks: {},
  selected: [],
  items: [],
  filteredChunks: {},
  filter: '',
  error: null,
  publicAccess: {
    enabled: false,
  },
};

const filterChunks = (chunks, filterHolder = '') => {
  let filteredChunks = chunks;
  const filter = filterHolder.replace(/[^a-zA-Z0-9 ]/g, '');

  if (filter !== '') {
    filteredChunks = _pickBy(chunks, chunk => {
      const rgx = new RegExp(`(${filter})`, 'gi');
      const author = chunk.author && chunk.author ? chunk.author : null;
      const email = chunk.email && chunk.email ? chunk.email : null;
      const title = chunk.title && chunk.title ? chunk.title : null;
      return rgx.test(author) || rgx.test(email) || rgx.test(title);
    });
  }
  const items = Object.keys(filteredChunks);

  return { filteredChunks, items };
};

const diaryData = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DIARY_DATA:
      return {
        ...state,
        pending: true,
        error: null,
      };

    case RECEIVE_DIARY_DATA:
      return {
        ...state,
        chunks: action.data,
        selected: [],
        filteredChunks: action.data,
        items: _keys(action.data),
        pending: false,
        error: null,
      };

    case FILTER_DIARY_DATA:
      return {
        ...state,
        ...filterChunks(state.chunks, action.payload),
        filter: action.payload,
      };

    case SELECT_DIARY: {
      const prevState = state.filteredChunks[action.key].selected;

      return {
        ...state,
        filteredChunks: {
          ...state.filteredChunks,
          [action.key]: {
            ...state.filteredChunks[action.key],
            selected: !prevState,
          },
        },
        selected:
          prevState === true
            ? _without(state.selected, action.key)
            : state.selected.concat(action.key),
      };
    }

    case SELECT_ALL_DIARIES: {
      const filteredChunks = _pick(state.filteredChunks, state.items);
      const selectedChunks = _mapValues(filteredChunks, chunk => ({
        ...chunk,
        selected: true,
      }));
      const selected = _union(state.selected, _keys(filteredChunks));
      return {
        ...state,
        filteredChunks: {
          ...state.filteredChunks,
          ...selectedChunks,
        },
        selected,
        selectAll: true,
      };
    }

    case DESELECT_ALL_DIARIES:
      return {
        ...state,
        filteredChunks: _mapValues(state.filteredChunks, chunk => ({
          ...chunk,
          selected: false,
        })),
        selected: [],
        selectAll: false,
      };

    default:
      return state;
  }
};

export default diaryData;
